// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3U7cq","info":"UpdateTermsInfo_info__31vFY"};